import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuthenticationContext } from "../context/AuthenticationContext";
import { oauthValidate } from "../services/LoginService";
import { setCookie } from "../utils/cookies";

export function GoogleAuth() {
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string>("");
    const location = useLocation();
    const navigate = useNavigate();
    const { setUser } = useAuthenticationContext();

    useEffect(() => {
        const handleGoogleCallback = async () => {
            const params = new URLSearchParams(location.search);
            const code = params.get("code");
            const state = params.get("state");

            if (!code || !state) {
                setError("Código de autorização não encontrado");
                setLoading(false);
                return;
            }

            try {
                const response = await oauthValidate(code, state);

                if (response.status === 200) {
                    // Store tokens in cookies
                    setCookie("token", response.data.access_token);

                    // Redirect to home page
                    navigate("/inicio");
                } else {
                    setError("Falha na autenticação com o Google");
                    setLoading(false);
                }
            } catch (err) {
                console.error("Google authentication error:", err);
                setError("Ocorreu um erro ao processar a autenticação com o Google");
                setLoading(false);
            }
        };

        handleGoogleCallback();
    }, [location.search, navigate]);

    return (
        <div className="flex min-h-screen w-full items-center flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8 bg-gray-50 gap-4">
            <img src="/images/logo-blue.png" alt="Cofrim" className="h-20 w-auto cursor-pointer" onClick={() => navigate("/home")} />
            <div className="border-primaryBorder border bg-primaryBg rounded-2xl p-8 max-w-md flex w-full flex-col items-center gap-4">
                {loading ? (
                    <>
                        <h2 className="text-primary font-primary text-xl mb-4">Autenticando com Google</h2>
                        <div className="flex justify-center">
                            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
                        </div>
                        <p className="text-sm text-gray-600 mt-4">Por favor, aguarde enquanto completamos o processo de autenticação...</p>
                    </>
                ) : error ? (
                    <>
                        <h2 className="text-primary font-primary text-xl mb-4">Falha na Autenticação</h2>
                        <div className="text-red-600 mb-4">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                            </svg>
                        </div>
                        <p className="text-sm text-gray-700 mb-4 text-center">{error}</p>
                        <button
                            onClick={() => navigate("/login")}
                            className="bg-blue-600 hover:bg-blue-700 px-6 py-2 rounded-2xl text-white font-medium transition-colors"
                        >
                            Voltar para o Login
                        </button>
                    </>
                ) : null}
            </div>
        </div>
    );
}

export default GoogleAuth;